import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { getStatus } from "../../../helpers/shipmentStatusHelpers";

export default class MillStatusCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    millOrderStatus: PropTypes.object
  };

  static defaultProps = {
    className: "",
    millOrderStatus: {}
  };

  maybeOverflowedRef = React.createRef();

  handleToggleIsContentVisible = () => {
    if (this.maybeOverflowedRef.current.offsetWidth + 1 < this.maybeOverflowedRef.current.scrollWidth) {
      this.setState({ isContentVisible: !this.state.isContentVisible });
    }
  };

  render() {
    const status = getStatus(this.props.millOrderStatus);

    return (
      <p
        className={classNames("data-grid__data", this.props.className)}
        onMouseEnter={this.handleToggleIsContentVisible}
        onMouseLeave={this.handleToggleIsContentVisible}
        ref={this.maybeOverflowedRef}>
        <span className={classNames("list-status__label", status.className)}>{status.label}</span>
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MillOrder/DataGrid/MillStatusCell.js